import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import ClipLoader from "react-spinners/ClipLoader";
import { variables } from '../Variables';
import { getToken } from '../TokenController';
import './Fileuploader.css'; // Import CSS for the spinner
const FileDropUploader = () => {
    const [loading, setLoading] = useState(false)
    const [fileName, setFileName] = useState('');
    const [uploadStatus, setUploadStatus] = useState('');
    const [errorMessages, setErrorMessages] = useState([]);

    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setLoading(true)
            const file = acceptedFiles[0];
            setFileName(file.name);
            convertToBase64(file);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: false
    });

    const convertToBase64 = (file) => {
        const reader = new FileReader();
        reader.onload = () => {


            const base64String = reader.result.split(',')[1];
            sendToApi(base64String);
        };
        reader.onerror = () => {
            setUploadStatus('Error reading file');
        };
        reader.readAsDataURL(file);
    };

    const sendToApi = async (base64String) => {
        try {
            const tkn = await getToken();
            console.log(tkn)
            const response = await fetch(`${variables.API_URL}/api/assets/excel/import`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + tkn,
                },
                body: JSON.stringify({
                    base64String: base64String,
                    fileName: 'ddssd'

                }),

            });

            const data = await response.json();
            console.log(data)
            if (data && data.length > 0) {
                const errors = data.map((item) => `Asset ID: ${item.assetid}, Error: ${item.error}`);
                setErrorMessages(errors);
                setUploadStatus('File uploaded with errors');
            } else {
                setErrorMessages([]);
                setUploadStatus('File uploaded successfully');
            }

        } catch (error) {
            setUploadStatus('Error uploading file');
            setErrorMessages([]);

        } finally {
            setLoading(false);
        }

    };

    return (
        <div
            {...getRootProps()}
            style={{
                border: '2px dashed #ccc',
                borderRadius: '10px',
                padding: '20px',
                textAlign: 'center',
                width: '500px',
                margin: '20px auto',
                backgroundColor: isDragActive ? '#f0f8ff' : 'white',
            }}
        >
            <input {...getInputProps()} />
            <ClipLoader
                color={"#0000FF"}
                loading={loading}
                size={80}
                aria-label="Loading Spinner"
               />
            <p>{isDragActive ? 'Drop the file here...' : 'Drag and drop a file here, or click to select one'}</p>
            {fileName && <p>File: {fileName}</p>}
            {uploadStatus && <p>Status: {uploadStatus}</p>}
            {errorMessages.length > 0 && (
                <div>
                    <h4>Error Details:</h4>
                    <ul>
                        {errorMessages.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default FileDropUploader;